var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-sidebar', {
    attrs: {
      "id": _vm.id,
      "title": _vm.title,
      "right": _vm.right,
      "backdrop": _vm.backdrop,
      "bg-variant": "white",
      "shadow": "",
      "width": _vm.computedWidth,
      "no-close-on-backdrop": _vm.noCloseOnBackdrop,
      "no-close-on-esc": _vm.noCloseOnEsc
    },
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }, [_c('div', {
    staticClass: "h-100 p-4 overflow-auto",
    staticStyle: {
      "background": "#f3f6f7"
    }
  }, [_vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }